import { render, staticRenderFns } from "./MainContentsBfLogin.vue?vue&type=template&id=f4e8cb88"
import script from "./MainContentsBfLogin.vue?vue&type=script&lang=js"
export * from "./MainContentsBfLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4e8cb88')) {
      api.createRecord('f4e8cb88', component.options)
    } else {
      api.reload('f4e8cb88', component.options)
    }
    module.hot.accept("./MainContentsBfLogin.vue?vue&type=template&id=f4e8cb88", function () {
      api.rerender('f4e8cb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main/MainContentsBfLogin.vue"
export default component.exports